module.exports = __webpack_public_path__ + "static/32-THE-WAR-FOR-TALENT-11d5280d5fa9cf9811e622e300c06413.jpg";